export const ENDPOINTS = {
  TOP_PACKAGES: 'home/topPackages',
  DOWNLOAD_ITINARARY: 'home/download-itinerary',
  CONTACT_US: 'home/contact-us',
  UPCOMING_EVENTS: 'home/upcoming-event',
  CATEGORY_WISE_PACKAGES: 'home/latest-packages-by-category',
  CATEGORIES: 'home/categories',
  TOP_DESTINATIONS: 'home/topDestinationPackage',
  MY_PROFILE: 'home/my-profile',
  UPDATE_PROFILE: 'home/update-profile',
  UPDATE_PROFILE_IMAGE: 'file/upload',
  LOGIN: '/auth/login',
  VERIFY_OTP: '/auth/verifyOtp',
  CREATE_ORDER: '/orders',
  CREATE_ORDER_INSTANCE: '/orders/instance',
  VERIFY_PAYMENT: '/orders/payment-verify',
  VALIDATE_COUPON: '/coupon/validate'
}; 